<template>
  <main>
    <b-row>
      <b-col lg="3" sm="6">
        <statistic-card-horizontal @onClick="$router.push('/penjualan')" icon="ShoppingCartIcon" color="primary" :statistic="cardPenjualan" statistic-title="Total Penjualan" />
      </b-col>
      <b-col lg="3" sm="6">
        <statistic-card-horizontal @onClick="$router.push('/kendaraan-barang')" icon="BoxIcon" color="success" :statistic="cardStokBarang" statistic-title="Stok Barang Mobil" />
      </b-col>
      <b-col lg="3" sm="6">
        <statistic-card-horizontal @onClick="$router.push('/collection')" icon="CreditCardIcon" color="warning" :statistic="cardCollection" statistic-title="Collection" />
      </b-col>
      <b-col lg="3" sm="6">
        <statistic-card-horizontal @onClick="$router.push('/rank-sales')" icon="BarChart2Icon" color="danger" :statistic="cardSales" statistic-title="Rank Sales" />
      </b-col>
      <b-col cols="12">
        <sales-graphic />
      </b-col>
      <br />
      <br />
    </b-row>
  </main>
</template>
<script>
import { BAlert } from "bootstrap-vue";
import { BTabs, BTab, BRow, BCol, BCard } from "bootstrap-vue";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
import SalesGraphic from './_penjualan.vue'
export default {
  data() {
    return {
      dataPenjualan: {},
      card: {}
    };
  },
  components: {
    SalesGraphic,
    StatisticCardHorizontal,
    BAlert,
    BTabs,
    BTab,
    BRow,
    BCol,
    BCard
  },
  computed: {
    myName() {
      if (this.user) {
        return this.user.karyawan ? this.user.karyawan.nama_lengkap : this.user.email;
      }

      return null;
    },
    cardPenjualan() {
      return "Rp " + this.formatRupiah(this.card.penjualan);
    },
    cardStokBarang() {
      return "Rp " + this.formatRupiah(this.card.barangMobilNilai);
    },
    cardCollection() {
      return "Rp " + this.formatRupiah(this.card.collection);
    },
    cardSales() {
      return this.card.sales + " Orang";
    },
  },
  methods: {
    postCardInfo() {
      let payload = {
        show: {
          penjualan: true,
          sales: true,
          karyawan: false,
          collection: true,
          assetTotal: false,
          assetNilai: false,
          barangMobilNilai: true,
          keuntungan: false,
        },
      };

      this.$store
        .dispatch("dashboard/cardInfo", payload)
        .then((res) => {
          this.card = res;
        })
        .catch((e) => console.error(e));
    },
  },

  mounted() {
    this.postCardInfo();
  },
};
</script>
